/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';
/**
 * Internal dependencies
 */
/**
 * Internal dependencies
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { TfiLayoutSlider } from "react-icons/tfi";
import advancejson from '@vayu-blocks/advance-panel/advance.json';
import settings from './settings/settings.json';
import style from './style/style.json';
const { name } = metadata;
registerBlockType(name, {
    ...metadata, 
    attributes: {
        ...metadata.attributes,
        ...advancejson,
        ...settings,
        ...style,
    },
    example: {},
    icon: <TfiLayoutSlider style={{color:'#6c1bc3'}} />,
    edit,
    save,
});
